import { http } from "./http";
import {
  GET_SALES_CONFIG_LIST_URL,
  SAVE_SALES_CONFIG_URL,
  UPDATE_SALES_CONFIG_URL,
} from "./URL";

export type SalesConfigTargetRatePayload = {
  targetRange: string;
  targetCompPercent: number;
  active?: boolean;
};

export type SalesConfigPayload = {
  salesConfigId?: number;
  isrId: number;
  invoiceYear: number;
  effectiveFrom: string;
  effectiveTo?: string;
  alignment: string;
  scope: string;
  rateType: string;
  standardCompPercent?: number;
  targetRates?: SalesConfigTargetRatePayload[];
};

const skipGlobalErrorPopup = { skipErrorPopup: true };

export const getSalesConfigList = async (payload: Record<string, unknown> = {}) => {
  const response = await http.post(GET_SALES_CONFIG_LIST_URL, payload);
  return response;
};

export const saveSalesConfig = async (payload: SalesConfigPayload) => {
  const response = await http.post(SAVE_SALES_CONFIG_URL, payload, undefined, skipGlobalErrorPopup);
  return response;
};

export const updateSalesConfig = async (payload: SalesConfigPayload) => {
  const response = await http.post(UPDATE_SALES_CONFIG_URL, payload, undefined, skipGlobalErrorPopup);
  return response;
};
